<template>
  <p
    v-if="status && fileStatus"
    :class="fileStatus.class">
    <sc-tooltip
      v-if="shouldShowTooltip"
      :label="fileStatus.help"
      class="sc-order-importer-table__tooltip"
      type="is-light"
      position="is-left"
      dashed>
      <sc-icon
        class="sc-order-importer-table__tooltip__icon"
        :icon="fileStatus.icon"
        size="is-small" />
      {{ fileStatus.label }}
    </sc-tooltip>

    <template v-else>
      <sc-icon
        :icon="fileStatus.icon"
        size="is-small" />
      {{ fileStatus.label }}
    </template>
  </p>
</template>
<script>
  import { ScIcon, ScTooltip } from '@intelipost-js/secure-components';
  import importFileStatus from '../../enums/importFileStatus.enum';

  export default {
    name: 'sc-status-file-import',
    props: {
      status: {
        type: String,
        required: true,
      },
    },
    computed: {
      fileStatus() {
        return (this.status && importFileStatus[this.status]) ?
          importFileStatus[this.status] : null;
      },
      shouldShowTooltip() {
        const { help } = this.fileStatus || {};
        return !!help;
      },
    },
    components: {
      ScIcon,
      ScTooltip,
    },
  };
</script>
<style lang="scss" scoped>
  .sc-order-importer-table__tooltip {
    cursor: help;
    padding: 2px 0;

    &__icon {
      margin-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/components/sc-status-file-import/ScStatusFileImport.vue